import { render } from "./DurationMeterPanel.vue?vue&type=template&id=182b354f&scoped=true"
import script from "./DurationMeterPanel.vue?vue&type=script&lang=js"
export * from "./DurationMeterPanel.vue?vue&type=script&lang=js"

import "./DurationMeterPanel.vue?vue&type=style&index=0&id=182b354f&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-182b354f"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QBtnToggle from 'quasar/src/components/btn-toggle/QBtnToggle.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QBtnGroup from 'quasar/src/components/btn-group/QBtnGroup.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QIcon,QMenu,QList,QItem,QItemSection,QTooltip,QBtnToggle,QSelect,QBtnGroup});qInstall(script, 'directives', {ClosePopup});
